import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import userIcon from "../../assets/user_approved.png";
import LoadingOverlay from "../Dashboard/Common/LoadingOverlay";
import AuthStatusPage from "./AuthStatusPage";

const ApproveUser = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { approvalCode } = useParams();
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("success");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!approvalCode) {
      setStatus("Approval link is missing or invalid.");
      setStatusType("error");
      setIsLoading(false);
      return;
    }

    let isMounted = true;

    const approveUser = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${apiUrl}/auth:approve_user?approval_code=${approvalCode}`,
        );

        if (!isMounted) {
          return;
        }

        if (response.ok) {
          setStatus("User approved.");
          setStatusType("success");
        } else {
          setStatus("Verification failed. Please try again.");
          setStatusType("error");
        }
      } catch {
        if (!isMounted) {
          return;
        }
        setStatus("An error occurred. Please try again.");
        setStatusType("error");
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    approveUser();

    return () => {
      isMounted = false;
    };
  }, [apiUrl, approvalCode]);

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    isLoading ? (
      <LoadingOverlay />
    ) : (
      <AuthStatusPage
        pageTitle="User Approval | EMAlpha"
        topBarCtaLabel="Log in"
        topBarCtaTo="/login"
        icon={userIcon}
        iconAlt="User approval"
        eyebrow={statusType === "success" ? "Approved" : "Approval issue"}
        title={statusType === "success" ? "User approved" : "Approval failed"}
        description={status}
        tone={statusType}
        primaryAction={{ label: "Back to log in", onClick: navigateToLogin }}
      />
    )
  );
};

export default ApproveUser;
